var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClosecomponent = function SvgClosecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.143 0 1.768 1.768L1.769 15.91 0 14.142z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.768 1.768 0 15.91 14.142l-1.768 1.768z"
  })));
};
export default SvgClosecomponent;